/**
 * Sorting utilities for supplement label items (lines, blends, constituents).
 * Normalizes amounts to micrograms for consistent ordering.
 */

/**
 * Normalize amount to micrograms for sorting purposes.
 * Treats ml as equivalent to mg (1:1 ratio) since we're doing
 * relative comparisons within a single label, not scientific conversion.
 */
export function normalizeToMcg(amount, unit) {
  const num = parseFloat(amount) || 0;
  switch ((unit || "").toLowerCase()) {
    case "g":
      return num * 1000000;
    case "mg":
    case "ml":
      return num * 1000;
    case "mcg":
      return num;
    default:
      return num * 1000;
  }
}

/**
 * Sort items by amount descending.
 * Uses stable sort - items with equal amounts maintain their relative order.
 */
export function sortByAmountDesc(items, amountKey = "amount", unitKey = "unit") {
  return [...items].sort((a, b) => {
    const aVal = normalizeToMcg(a[amountKey], a[unitKey]);
    const bVal = normalizeToMcg(b[amountKey], b[unitKey]);
    return bVal - aVal;
  });
}

/**
 * Sort constituents by amount descending.
 * Convenience wrapper with constituent-specific defaults.
 */
export function sortConstituentsDesc(constituents) {
  return sortByAmountDesc(constituents, "amount", "unit");
}
